import { FC, PropsWithChildren } from "react";
import styles from "./Center.module.css";

const Center: FC<PropsWithChildren> = ({ children }) => <div className={styles.center}>{children}</div>;

export default Center;
